// extracted by mini-css-extract-plugin
module.exports = {"button":"DownloadButton_button__23dmQ","arrow":"DownloadButton_arrow__3QP1B"};